(function () {
  'use strict';

  var header = document.querySelector('[data-header]');
  var quickBuy = document.querySelector('[data-quick-buy]');

  function onScroll() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 24);
    if (quickBuy) quickBuy.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.85);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Reveal on scroll */
  var reveals = Array.prototype.slice.call(document.querySelectorAll('.reveal'));

  if ('IntersectionObserver' in window && reveals.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );
    reveals.forEach(function (element) {
      observer.observe(element);
    });
  } else {
    reveals.forEach(function (element) {
      element.classList.add('is-visible');
    });
  }

  /* Gallery */
  var gallery = document.querySelector('[data-gallery]');
  var galleryMain = gallery ? gallery.querySelector('[data-gallery-main]') : null;

  function showImage(src, alt) {
    if (!galleryMain || !src) return;
    galleryMain.removeAttribute('srcset');
    galleryMain.setAttribute('src', src);
    if (alt) galleryMain.setAttribute('alt', alt);
  }

  if (gallery) {
    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-thumb]');
      if (!thumb) return;
      var image = thumb.querySelector('img');
      showImage(thumb.getAttribute('data-src'), image ? image.getAttribute('alt') : '');
      gallery.querySelectorAll('[data-thumb]').forEach(function (button) {
        button.classList.toggle('is-active', button === thumb);
      });
    });
  }

  /* Variant selection */
  var variantSource = document.querySelector('[data-variants]');
  var variants = [];

  if (variantSource) {
    try {
      variants = JSON.parse(variantSource.textContent) || [];
    } catch (error) {
      variants = [];
    }
  }

  var optionGroups = Array.prototype.slice.call(document.querySelectorAll('[data-option-index]'));

  function selectedOptions() {
    return optionGroups.map(function (group) {
      var checked = group.querySelector('[data-option-value]:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant() {
    if (!variants.length) return null;
    if (!optionGroups.length) return variants[0];
    var selected = selectedOptions();
    for (var index = 0; index < variants.length; index += 1) {
      var options = variants[index].options || [];
      if (options.length !== selected.length) continue;
      var matches = options.every(function (option, position) {
        return option === selected[position];
      });
      if (matches) return variants[index];
    }
    return null;
  }

  function paintVariant(variant) {
    var available = variant ? variant.available !== false : false;

    document.querySelectorAll('[data-variant-id]').forEach(function (input) {
      if (variant) input.value = variant.id;
    });

    document.querySelectorAll('[data-price]').forEach(function (element) {
      if (variant) element.textContent = variant.price;
    });

    document.querySelectorAll('[data-compare]').forEach(function (element) {
      if (variant && variant.compare) {
        element.textContent = variant.compare;
        element.classList.remove('is-hidden');
      } else {
        element.classList.add('is-hidden');
      }
    });

    document.querySelectorAll('[data-sale-badge]').forEach(function (element) {
      element.classList.toggle('is-hidden', !(variant && variant.compare));
    });

    document.querySelectorAll('[data-buy-now], [data-add-to-cart]').forEach(function (button) {
      button.disabled = !available;
    });

    document.querySelectorAll('[data-unavailable]').forEach(function (element) {
      element.hidden = available;
    });

    document.querySelectorAll('[data-buy-root]').forEach(function (root) {
      root.classList.toggle('is-unavailable', !available);
    });
  }

  if (optionGroups.length) {
    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-option-value]')) return;
      paintVariant(findVariant());

      optionGroups.forEach(function (group) {
        group.querySelectorAll('.option__pill').forEach(function (pill) {
          var input = pill.querySelector('[data-option-value]');
          pill.classList.toggle('is-selected', input && input.checked);
        });
      });
    });
  }

  if (variants.length) paintVariant(findVariant());

  /* Quantity steppers, per form */
  document.querySelectorAll('[data-quantity]').forEach(function (stepper) {
    var form = stepper.closest('form');
    var input = form ? form.querySelector('[data-quantity-input]') : null;
    var output = stepper.querySelector('[data-qty-value]');
    var down = stepper.querySelector('[data-qty-down]');
    var up = stepper.querySelector('[data-qty-up]');

    function setQuantity(value) {
      var quantity = Math.min(Math.max(value, 1), 10);
      if (input) input.value = quantity;
      if (output) output.textContent = quantity;
      if (down) down.disabled = quantity <= 1;
      if (up) up.disabled = quantity >= 10;
    }

    if (down) down.addEventListener('click', function () { setQuantity(parseInt(input.value, 10) - 1); });
    if (up) up.addEventListener('click', function () { setQuantity(parseInt(input.value, 10) + 1); });
    setQuantity(1);
  });
})();